function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgArrowCircleLeft = function SvgArrowCircleLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54062",
    transform: "translate(21866 18106)"
  }, /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1878",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(-21866 -18106)",
    style: {
      fill: "currentColor"
    }
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54060"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 25840",
    d: "M14.6 27.256a2.155 2.155 0 0 1-1.32-.456L.973 17.388a2.609 2.609 0 0 1-.045-4.028l11.954-9.616a2.184 2.184 0 0 1 3.209.515 2.624 2.624 0 0 1-.475 3.479L6.208 15.3l9.717 7.434a2.622 2.622 0 0 1 .551 3.465 2.243 2.243 0 0 1-1.876 1.057",
    transform: "translate(-21851 -18096.256)",
    style: {
      fill: "#80a9f7"
    }
  }))));
};

export default SvgArrowCircleLeft;